/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".logo[_ngcontent-%COMP%]{width:120px;height:31px;background:rgba(255,255,255,.2);margin:16px 28px 16px 0;float:left}.main[_ngcontent-%COMP%]{height:100%}leap-navbar[_ngcontent-%COMP%]{position:fixed;top:0;width:100%;z-index:100}"];
export { styles as styles };
